import { SortDirection } from 'react-virtualized';

export const PAGES_SORT_KEY_SCREENSHOT = 'screenshot';
export const PAGES_SORT_KEY_NAME = 'name';
export const PAGES_SORT_KEY_CREATED_AT = 'created';
export const PAGES_SORT_KEY_EDITED_AT = 'edited-at';
export const PAGES_SORT_KEY_PUBLISHED_AT = 'published-at';
export const PAGES_SORT_KEY_VISIT_COUNT = 'visits';
export const TEMPLATES_SORT_KEY_SITES_CREATED = 'sites-created';

export const SORT_DIR_ASC = SortDirection.ASC;
export const SORT_DIR_DESC = SortDirection.DESC;

export const SITES_TAB_NAME = 'sites';
export const TEMPLATES_TAB_NAME = 'templates';

export const SITES_SEARCH_MODE = 1;
export const TEMPLATES_SEARCH_MODE = 2;

export const PAGE_STATUS_TYPE_ACTIVE = 'active';
export const PAGE_STATUS_TYPE_ARCHIVED = 'archived';
export const PAGE_STATUS_TYPE_DEACTIVATED = 'deactivated';
export const PAGE_STATUS_TYPE_REDIRECTED = 'redirected';
export const PAGE_STATUS_TYPE_NEVER_PUBLISHED = 'never_published';
export const PAGE_STATUS_TYPE_SCHEDULED_FOR_DEACTIVATION = 'scheduled_deactivation';
export const PAGE_STATUS_TYPE_SCHEDULED_FOR_REDIRECT = 'scheduled_redirect';

export const DEFAULT_STATUS_TYPES = [
  { label: 'Active', value: PAGE_STATUS_TYPE_ACTIVE },
  { label: 'Never Published', value: PAGE_STATUS_TYPE_NEVER_PUBLISHED },
  { label: 'Scheduled to deactivate', value: PAGE_STATUS_TYPE_SCHEDULED_FOR_DEACTIVATION }
];
